import apiClient from "./MyClient";

export default {

  getAllTeams() {

    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token

    return apiClient.get("/api/teams");
  },

  getATeam(randomString) {

    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token

    return apiClient.get("/api/team/" + randomString);
  },

  saveNewTeam(name) {

    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token

    return apiClient.post("/api/team/store", name);
  },

  deleteTeamService(randomString) { 
    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token

    return apiClient.delete("/api/team/all-data/delete/" + randomString);
  },

  updateTeam(randomString, updatedData) {
    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token

    return apiClient.put("/api/team/update/" + randomString, updatedData);
  },

  getAllEmployees() {
    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token

    return apiClient.get("/api/manager/employees");
  },

  showTalksForThisEmployee(uuid) {
    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token

    return apiClient.get("/api/manager/employee/" + uuid);
  },

  deleteAEmployeeFromTeam(formData) {
    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token
    
    return apiClient.post("/api/team/delete/employee/", formData);
  },

  deleteAListOfEmployees(formData) {
    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token
    
    return apiClient.post("/api/team/delete/list-of-employees", formData);
  },


  deleteEmployeeCompletelyAcrossAllApps(formData) {
    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token
    
    return apiClient.post("/api/delete/employee/completely", formData);
  },


  copyEmployeesToThisTeam(formData) { 
    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token
    
    return apiClient.post("/api/team/copy/emploees/", formData); 
  },


  deleteSupervisorTeam(formData) { 

    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token
    
    return apiClient.post("/api/delete/supervisor/team/", formData); 
  },


  getDataForAddNewUsersView(formData) { 

    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token
    
    return apiClient.get("/api/get-data/add-new/users", formData); 
  },


  checkIfEmailIsVaildAndDoNotExistsInDBForToolboxTalk(formData){

    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token
    
    return apiClient.post("/api/toolbox-talk/validate-email", formData); 

  },


  toolboxTalkAppAdminFinallyAddNewUsersService(formData){

    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token
    
    return apiClient.post("/api/toolbox-talk/add-new-users", formData); 

  },


  activateReativateUserService(formData){

    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token
    
    return apiClient.post("/api/update/employee-status", formData); 

  },


  updateUserDetailsService(formData){

    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token
    
    return apiClient.post("/api/update/employee-details", formData); 

  },


  getDataForAddNewGroupTalkUsersService(){

    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token

    return apiClient.get("/api/add/group-talk/users");

  },


  toolboxTalkGroupTalkAdminFinallyAddNewUsersService(formData){

    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token
    
    return apiClient.post("/api/add/new-group-talk/users", formData); 

  },


  getAManagerAppsAccessStatusForGroupTalkService(){

    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token

    return apiClient.get("/api/get/manager-talks-access-level");

  },

  getTeamDeletionLogsService(){

    const authStore = localStorage.getItem('authStore')
    apiClient.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(authStore).token

    return apiClient.get("/api/all/team-deletion/logs");

  }

  


};
